import { VStack, Text, Button, Box, Link } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import Background from 'assets/common/background.png';
import { ExternalRoutes, PublicRoutes } from 'types/Routes';
import { ReactElement } from 'react';
import { PageContext } from 'components/common/PageContext';
import { useCaseMeModal } from 'hooks/useCaseMeModal';
import { useBreakpoint } from '../../hooks/utils/layout/useBreakpoint';
import { Breakpoints } from '../../types/breakpoints';

export const Landing = (): ReactElement => {
  const navigate = useNavigate();
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);
  useCaseMeModal();

  const navigateTo = (route: PublicRoutes): void => {
    navigate(route);
  };

  return (
    <PageContext headTitle="Die #1 Lernapp für Pflege-Azubis">
      <>
        {!isDesktop && (
          <Box
            bgImage={`url(${Background})`}
            w="full"
            h="50vh"
            bgSize="contain"
            bgPos="center"
            bgRepeat="no-repeat"
            mt="2vh"
          />
        )}
        <VStack align="center" textAlign="center" px="3" gap="xs">
          <VStack gap="s">
            <Text textStyle="h1.medium" color="text.primary">
              Willkommen bei Novaheal
            </Text>
            <Text textStyle="h4.regular" color="text.primary" pt="5">
              Sicher durch die Ausbildung, mehr Freizeit
              <br />
              und bessere Noten!
            </Text>
          </VStack>
          <VStack w="full" gap="4" pb="4">
            <Button variant="primary" w="full" onClick={() => navigateTo(PublicRoutes.REGISTER)}>
              Registrieren
            </Button>
            <Button
              variant="secondaryOutline"
              w="full"
              onClick={() => navigateTo(PublicRoutes.LOGIN)}
            >
              Login
            </Button>
          </VStack>
        </VStack>
      </>
    </PageContext>
  );
};
